import { SectionWiseDataModal } from "./sections-wise-data.modal";

export class CreatePaperModelReq {
    id: number;
    classId: number;
    subject: number;
    noOfSections: number;
    marks: number;
    totalQuestions: number;
    timeLimit: number;
    tagline: string;
    partName: string;
    language: number;
    instructions: any;
    sections: SectionWiseDataModal[];
    defaultBluePrint: boolean;
    languages: number[];
    bluePrintName:string;
    constructor(id: number,classId: number, subject: number, noOfSections: number, marks: number, totalQuestions: number, timeLimit: number, tagline: string, partName: string, language: number, instructions: any, sections: SectionWiseDataModal[],defaultBluePrint: boolean,languages:number[],bluePrintName:string,
    ) {
        this.id = id;
        this.classId = classId;
        this.subject = subject;
        this.noOfSections = noOfSections;
        this.marks = marks;
        this.totalQuestions = totalQuestions;
        this.timeLimit = timeLimit;
        this.tagline = tagline;
        this.partName = partName;
        this.language = language;
        this.instructions = instructions;
        this.sections = sections;
        this.defaultBluePrint = defaultBluePrint;
        this.languages = languages;
        this.bluePrintName = bluePrintName;
    }
}